import platUtil from './platUtil';
import uaUtil from './uaUtil';
import urlUtil from './urlUtil';
import tool from './tool';

export default {
    platUtil,
    uaUtil,
    urlUtil,
    tool
};
